__turbopack_context__.v({
  "actionBtn": "dialInCountriesTable-module-scss-module__4GNsbq__actionBtn",
  "addItemButton": "dialInCountriesTable-module-scss-module__4GNsbq__addItemButton",
  "addItemIcon": "dialInCountriesTable-module-scss-module__4GNsbq__addItemIcon",
  "countriesTableContainer": "dialInCountriesTable-module-scss-module__4GNsbq__countriesTableContainer",
  "countryIdCell": "dialInCountriesTable-module-scss-module__4GNsbq__countryIdCell",
  "countryIdFieldContainer": "dialInCountriesTable-module-scss-module__4GNsbq__countryIdFieldContainer",
  "countryInputMobileContainer": "dialInCountriesTable-module-scss-module__4GNsbq__countryInputMobileContainer",
  "countryOptionPhoneCode": "dialInCountriesTable-module-scss-module__4GNsbq__countryOptionPhoneCode",
  "dashRowCell": "dialInCountriesTable-module-scss-module__4GNsbq__dashRowCell",
  "deleteRowBtn": "dialInCountriesTable-module-scss-module__4GNsbq__deleteRowBtn",
  "deleteRowCell": "dialInCountriesTable-module-scss-module__4GNsbq__deleteRowCell",
  "dialInCountriesTitle": "dialInCountriesTable-module-scss-module__4GNsbq__dialInCountriesTitle",
  "disabledOptionCountryName": "dialInCountriesTable-module-scss-module__4GNsbq__disabledOptionCountryName",
  "dragCell": "dialInCountriesTable-module-scss-module__4GNsbq__dragCell",
  "questionIcon": "dialInCountriesTable-module-scss-module__4GNsbq__questionIcon",
  "questionIconContainer": "dialInCountriesTable-module-scss-module__4GNsbq__questionIconContainer",
  "tableRow": "dialInCountriesTable-module-scss-module__4GNsbq__tableRow",
});
